export default "__VITE_ASSET__56ba0b22__"